import React, { Component } from 'react'
import './index.less'
import SVGA from 'svgaplayerweb'
/**
 * @param {boolean} show 是否显示(必传)
 * @Author: KK
 * @Date: 2022-12-09
 * @LastEditors: KK
 * @LastEditTime: 2022-12-09
 * @tip: 加载动画（放入想要的盒子即可触发）
 */

export default class extends Component {
  componentDidMount(){
    
  }
  componentDidUpdate(e,b){
    if (e) {
      new SVGA.autoload(document.querySelector('#demoCanvas'))
    }
    return true
  }
  render() {
    let isShow = this.props.show || false
    return (
      isShow && (
        <div className="zhi-loader-compbox">
          <div className="chatie" id="demoCanvas" src={`/img/ani_web_loading.svga`}>
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// src/component/LoadingComp/index.js